module.exports = __webpack_public_path__ + "static/media/bitcoin3.46c81ded.png";